import { css } from '@/styled-system/css';

// Fixed widths per column, applied to the header cells to drive the `tableLayout: fixed` columns.
export const tableCellContentWidths = {
  UNIT: css.raw({
    width: {
      // NOTE: use `100%` here to display row borders fully across the table
      base: '100%',
      lg: '300px',
    },
  }),
  RENT: css.raw({
    width: {
      base: 'auto',
      lg: '142px',
    },
  }),
  STATUS: css.raw({
    width: {
      base: 'auto',
      lg: '185px',
    },
  }),
  TENANTS: css.raw({
    width: {
      base: 'auto',
      lg: '150px',
    },
  }),
  OVERFLOW: css.raw({ width: '2000' }),
} as const;

// Fixed widths per column for the top-level "Units" table view (adds an Address column).
export const unitsViewTableCellContentWidths = {
  UNIT: css.raw({
    width: {
      // NOTE: use `100%` here to display row borders fully across the table
      base: '100%',
      lg: '280px',
    },
  }),
  ADDRESS: css.raw({
    width: {
      base: 'auto',
      lg: '200px',
    },
  }),
  RENT: css.raw({
    width: {
      base: 'auto',
      lg: '142px',
    },
  }),
  STATUS: css.raw({
    width: {
      base: 'auto',
      lg: '185px',
    },
  }),
  TENANTS: css.raw({
    width: {
      base: 'auto',
      lg: '150px',
    },
  }),
  OVERFLOW: css.raw({ width: '2000' }),
} as const;

// Fixed widths per column for the top-level "Properties" table view.
export const propertyTableCellContentWidths = {
  ADDRESS: css.raw({
    width: {
      // NOTE: use `100%` here to display row borders fully across the table
      base: '100%',
      lg: '400px',
    },
  }),
  TYPE: css.raw({
    width: {
      base: 'auto',
      lg: '240px',
    },
  }),
  UNITS: css.raw({
    width: {
      base: 'auto',
      lg: '240px',
    },
  }),
  OVERFLOW: css.raw({ width: '2000' }),
} as const;

export const overflowMenuStyles = css.raw({
  position: 'absolute',
  insetInlineEnd: '400',
  insetBlockStart: '50%',
  transform: 'translateY(-50%)',
  flexShrink: 0,
});

// Address column thumbnail for the top-level Properties table; hidden on small screens
// so the address details get the full width.
export const propertyThumbnailStyles = css.raw({
  display: { base: 'none', md: 'block' },
  // oxlint-disable-next-line constellation/no-raw-spacing-values
  width: '120px',
  height: '2000',
  flexShrink: 0,
  borderRadius: 'obj.default',
  overflow: 'hidden',
});

export const tenantsListStyles = css.raw({
  display: 'flex',
  alignItems: 'center',
  gap: '200',
  minWidth: 0,
});

// Gleam's tones are all feedback colors (notify red, info blue); the design uses the neutral
// impact pair. It also renders the bare count, so the leading "+" comes from a pseudo-element —
// presentational only, since the trigger's aria-label carries the meaning.
export const tenantsOverflowGleamStyles = css.raw({
  backgroundColor: 'bg.impact',
  color: 'text.onImpact.neutral-fixed',
  // eslint-disable-next-line curly-quotes/no-straight-quotes -- CSS `content` needs straight quotes
  _before: { content: '"+"' },
});

// UnstyledButton wrapping the overflow-count Gleam that triggers the additional-tenants popover.
// It resets its own chrome via `all: unset`, so this only restores the tap area and focus ring
// that FilterChip used to provide for the ~20px Gleam.
export const tenantsOverflowTriggerStyles = css.raw({
  position: 'relative',
  display: 'inline-flex',
  alignItems: 'center',
  flexShrink: 0,
  cursor: 'pointer',
  focusOutline: true,
  _after: {
    // eslint-disable-next-line curly-quotes/no-straight-quotes -- CSS `content` needs straight quotes
    content: '""',
    position: 'absolute',
    height: 'tapArea.mobile.default',
    minWidth: 'tapArea.mobile.default',
    width: '100%',
    left: '0',
    top: '50%',
    marginTop: 'calc(({sizes.tapArea.mobile.default} / 2) * -1)',
  },
});
